import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // No agregar token a la petición de login
  if (req.url.includes('/Auth/login')) {
    return next(req);
  }

  const authService = inject(AuthService);

  // Verificar si el token está expirado antes de hacer la petición
  if (authService.isTokenExpired()) {
    // Token expirado, cerrar sesión automáticamente
    authService.logoutWithMessage();
    // No continuar con la petición
    return throwError(() => new Error('Token expirado'));
  }

  const token = authService.getToken();

  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si el servidor devuelve 401 (No autorizado), verificar si el token está expirado
        if (error.status === 401) {
          if (authService.isTokenExpired()) {
            authService.logoutWithMessage();
          }
        }
        return throwError(() => error);
      })
    );
  }

  return next(req);
};
